<template>
	<div class="container">
		<div class="warn_work" style="width: 4.35rem;">
			<div class="title">
				<img src='../../assets/img/tit.png' style='height:.2rem;' />
				<img src='../../assets/img/tit.png' style='height:.2rem;' />
				监控数据
			</div>	
			<div class="info" style="justify-content: space-evenly;">
				<div class="datapic" v-if="camerainfos.length == 0">
					<div>
						<img :src="localpic3" style="width: 1rem;height: 1rem;" @click="picScale(localpic3)" />
					</div>
					<div>暂无抓拍</div>
				</div>											
				<div class="datapic"  v-for="(item,index) in camerainfos" v-else> 
					<div>
						<el-image
							style="width: 1rem;height: 1rem;" 
							fit="contain"										
							:src="item.filePath" 
							@click="picScale(item.filePath)" >
						</el-image>
					</div>						
					<div>{{item.errorCode}}</div>
					<div class="fonto">{{item.createTime}}</div>
				</div>	
											
				<el-dialog :visible.sync="picDialogVisible" title="抓拍图片展示" width="45%" class="picdialog" @close="handlePicDialogClose">
				    <el-image
				        style="width: 100%"
				        :src="picDialogPath"
				        fit="contain">
					</el-image>
					<div v-show="entyWarnToPic" class="row"> 
						<img src='../../assets/img/warn.png' style='height:.5rem;' />
						<div style="color: #fff;padding-top: 10px;">
							机器人停止，请注意查看是否有障碍物。可尝试点击"机器人绕障"
						</div>
					</div>
				</el-dialog>												
			</div>
			
			<div class="title_info">
				<img src='../../assets/img/tit2.png' style='height:.23rem;padding-right: .15rem;' />
				机器人脱困
			</div>
			<div class="info" style="justify-content: space-around;">
				<div class="datapic" style="padding-left: .15rem;">
					<div class="pic"  v-if="takepicshow != '' ">
						<el-image
							:src="takepicshow"
							style="width: 1rem;height: 1rem;"
							fit="contain"
							@click="picScale(takepicshow)"	>
						</el-image>
					</div>
					<div v-else>
						<img :src="localpic3" style="width: 1rem;height: 1rem;" @click="picScale(localpic3)" />
					</div>
					<el-button type="primary" size="mini" v-on:click="remotePicTask(0)">一键抓拍</el-button>			
				</div>
				<div style="display: flex;flex-direction:row;justify-content: space-around;">
					<div style="display: flex;flex-direction:column;justify-content: space-around;">
						<div class="datapic">
							<div class="pic" v-if="ctlpicshow != '' ">
							<!-- 	
								<img src="../../assets/img/lidar.jpg"
									style="width: 1rem;height: 1rem;" 
									fit="contain">
								</img > 
							-->
								<el-image
									:src="ctlpicshow"
									style="width: 1rem;height: 1rem;"
									fit="contain"
									@click="picScale(ctlpicshow)"	>
								</el-image>
							</div>	
							<div v-else>
								<img :src="localpic5" style="width: 1rem;height: 1rem;" @click="picScale(localpic5)" />
							</div>			
						</div>
						<el-button type="primary" size="mini" v-on:click="remotePicTask(1)">机器人绕障</el-button>		
					</div>	
					<div class="datapic" style="padding-left:.1rem" >
						<div>绕障开始:{{ctlrsp.timeBegin}}</div>		
						<div>绕障结束:{{ctlrsp.timeEnd}}</div>	
						<div>绕障时长:{{ctlrsp.timeDuration}}</div>
						<div>绕障状态:{{ctlrsp.bypassStatus == 1 ? '绕障中' : ctlrsp.bypassStatus == 3 ? '已结束' : '未开始'}}</div>		
					</div>											
				</div> 
			</div>	
			
		</div>
		
		<div class="warn_work" style="width:calc(100% - 5rem); ">
			<div class="title">
				<img src='../../assets/img/tit.png' style='height:.2rem;' />
				<img src='../../assets/img/tit.png' style='height:.2rem;' />
				<ul class="wktabdiv">
					<li class="wktabtit" v-for="(item,index) in wkTabs" @click="wkTabChange(index)" :class="{active:index == wkCurTab}">
						{{item}}
					</li>
				</ul>
				<select v-show="wkCurTab == 0" v-model="selectedWork" class="selector" @change="handleSelectWork(0)">
				      <option value="null">--请选择作业--</option>
				      <option v-for="(item, index) in workList" :key="item.id" :value="item">
						{{ item.missionName.indexOf('-') > 0 ? item.missionName.substring(0,item.missionName.indexOf('-')) : item.missionName}}
					  </option>
				</select>
				
				<select v-show="wkCurTab == 1" v-model="selectedWorkMulti" class="selector" @change="handleSelectWork(1)">  
				      <option value="null">--请选择组合作业--</option>
				      <option v-for="(item, index) in multiWorkList" :key="index" :value="item">{{ item.workName }}</option>
				</select>
				
				<div class="title_info" style="position: fixed;right:9.5rem;">
					<img src='../../assets/img/tit2.png' style='height:.23rem;padding-right: .15rem;' />
					作业工单
				</div>
				<div class="title_info" style="position: fixed;right: 1.1rem;width: 4rem;">
					<img src='../../assets/img/tit2.png' style='height:.23rem;padding-right: .15rem;' />
					历史工单
				</div>
			</div>	
			<div class="car_work" >
				<div style="display: flex;flex-direction: column;justify-content: space-around;">
					<div v-if="wkCurTab == 0" class="car_work" >
						<div class="workdetail">
							<div>
								<img src='../../assets/img/work_name.png' style='height:.2rem;align-self: center;padding: 0 .1rem' />
								作业名称
								<!-- {{selectedWork.missionName}} -->
								<div v-if="selectedWork">
									<div v-if="selectedWork.missionName && selectedWork.missionName.indexOf('-') > 0" >
										{{selectedWork.missionName.substring(0,selectedWork.missionName.indexOf('-'))}} 
									</div>
									<div v-else>
										{{selectedWork.missionName}}
									</div>
								</div>
							</div>
							<div>
								<img src='../../assets/img/work_func.png' style='height:.2rem;align-self: center;padding: 0 .1rem' />
								作业功能
								<div v-if="selectedWork">
									{{selectedWork.missionFunc}}
								</div>
							</div>
							<div style="display: flex;">
								<img src='../../assets/img/work_time.png' style='height:.2rem;align-self: center;padding: 0 .1rem' />
								作业时间				
								<div style="line-height: .3rem;">
									<div v-if="selectedWork" style="display: flex;flex-direction: column;padding-left: .1rem;">
										<div>{{selectedWork.missionRe}}	</div>
										<div>{{selectedWork.missionTime}}</div>
									</div>	
								</div>											
							</div>
							<div>
								<img src='../../assets/img/work_map.png' style='height:.2rem;align-self: center;padding: 0 .1rem' />
								地图名称
								<div v-if="selectedWork">
									<div v-if="selectedWork.missionMap && selectedWork.missionMap.indexOf('-') > 0" >
										{{selectedWork.missionMap.substring(0,selectedWork.missionMap.indexOf('-'))}} 
									</div>
									<div v-else>
										{{selectedWork.missionMap}}
									</div>
								</div>
							</div>
							<div>
								<img src='../../assets/img/work_traj.png' style='height:.2rem;align-self: center;padding: 0 .1rem' />
								轨迹名称
								<div v-if="selectedWork">
									<div v-if="selectedWork.missionTrack && selectedWork.missionTrack.indexOf('-') > 0" >
										{{selectedWork.missionTrack.substring(0,selectedWork.missionTrack.indexOf('-'))}} 
									</div>
									<div v-else>
										{{selectedWork.missionTrack}}
									</div>
								</div>
							</div>
						</div>
						<div class="worktraj">						
							<canvas id="myPicCanvas" ></canvas>
							<!-- <div v-if="selectedWork">
								<div v-if="selectedWork.networkPic" >
									<img :src="selectedWork.networkPic" style='height:2.5rem;align-self: center;'   />							
								</div>
							</div> -->						

							<el-dialog
							  :visible.sync="canvasZoomVisible"
							  title=""
							  width="60%"
							  height="50%"
							  
							  >	<!-- :before-close="handleCanvasBeforeClose" -->  <!-- @open="handleResize" -->
							  <canvas id="myPicCanvasZoom"></canvas>
							</el-dialog>				
							
						</div>	
						<div class="workbaidu">
							<!-- <div id="bmapTraj" style='height:2.5rem;align-self: center;'></div>	 -->
							<baidu-map scroll-wheel-zoom @ready="bmapTraj_ready" :zoom="19" style="height:2.5rem;align-self: center;"> </baidu-map>
						</div>
					</div>
					<div v-else  class="car_work" style="justify-content: space-between;">
						<div class="workdetail">
							<div>
								<img src='../../assets/img/work_name.png' style='height:.2rem;align-self: center;padding: 0 .1rem' />
								作业名称
								<div v-if="selectedWorkMulti">
									{{selectedWorkMulti.workName}}
								</div>
							</div>
							<div style="display: flex;">
								<img src='../../assets/img/work_time.png' style='height:.2rem;align-self: center;padding: 0 .1rem' />
								作业时间				
								<div style="line-height: .3rem;">
									<div v-if="selectedWorkMulti" style="display: flex;flex-direction: column;padding-left: .1rem;">
										<div>{{selectedWorkMulti.workRe == 2 ? '当日执行' : selectedWorkMulti.workRe == 1 ? '次日执行' :'立即执行'}}</div>
										<div>{{selectedWorkMulti.workTime}}  </div>
									</div>	
								</div>											
							</div>
							<div>
								<img src='../../assets/img/work_name.png' style='height:.2rem;align-self: center;padding: 0 .1rem' />
								子作业集
								<div v-if="selectedWorkMulti">
									<div v-if="selectedWorkMulti.subWork">
										{{selectedWorkMulti.subWork}}
									</div>								
								</div>
							</div>
						</div>
						<div class="workbaidu">
							<baidu-map scroll-wheel-zoom @ready="bmapTraj_ready" :zoom="19" style="height:2.5rem;align-self: center;"> </baidu-map>
						</div>
					</div>
					<div style="padding-top: .2rem;display: flex;flex-direction: row;justify-content: space-around;">
						<el-button type="primary" size="mini" v-on:click="remoteTask(0)" >作业下发</el-button>
						<el-button type="primary" size="mini" v-on:click="remoteTask(1)" >作业暂停</el-button>
						<el-button type="primary" size="mini" v-on:click="remoteTask(2)">作业继续</el-button>
						<el-button type="primary" size="mini" v-on:click="remoteTask(3)">作业结束</el-button>
						<el-button type="primary" size="mini" v-on:click="remoteTask(4)">机器人返航</el-button>
					</div>
				</div>		
				<div class="orderdetail">
					<div>
						<img src='../../assets/img/tit3.png' style='height:.16rem;align-self: center;' />
						<font>
							开始时间
							{{execuWorkOrder.workStart}}
						</font>
					</div>
					<div>
						<img src='../../assets/img/tit3.png' style='height:.16rem;align-self: center;' />
						<font>
							结束时间
							{{execuWorkOrder.workEnd}}
						</font>
					</div>
					<div>
						<img src='../../assets/img/tit3.png' style='height:.16rem;align-self: center;' />
						<font>
							清扫面积
							{{execuWorkOrder.workArea}}平方米
						</font>
					</div>
					<div>
						<img src='../../assets/img/tit3.png' style='height:.16rem;align-self: center;' />
						<font>
							清扫距离
							{{execuWorkOrder.workDistance}}米
						</font>
					</div>
					<div>
						<img src='../../assets/img/tit3.png' style='height:.16rem;align-self: center;' />
						<font>
							任务完成度
							{{execuWorkOrder.workCover}}%
						</font>
					</div>	
					<div>
						<img src='../../assets/img/tit3.png' style='height:.16rem;align-self: center;' />
						<font>
							是否组合作业
							{{execuWorkOrder.workType == 1 ? '是' : '否'}}
						</font>
					</div>
				</div>
				<div class="orderlist">
					<div class="title3">
						<div style="width: 20%;">工单id</div>
						<div style="width: 40%;">开始时间</div>
						<!-- <div>清扫距离</div> -->
						<div style="width: 20%;">清扫面积</div>
						<div style="width: 20%;">任务进展</div>
					</div>	
					<div class="orderlistdiv">
						<div v-for="item in orderList" class="orderlistinfo">
							<div style="width: 20%;">{{item.serialId.substring(14)}}</div>
							<div style="width: 40%;">{{item.timeStart}}</div>
							<!-- <div>{{item.distance}}</div> -->
							<div style="width: 20%;">{{item.area}}</div>
							<div style="width: 20%;">{{item.coverTraj}}</div>
							<el-button type="primary" size="mini" class="btn2" v-on:click="showOrderdetail(item)">详情</el-button>
						</div>
					</div>					
					<pagination :total="orderQuery.orderTotal" :page="orderQuery.pageIndex" layout='sizes,prev, pager, next'
					  @pagination="handleOrderPageList">
					</pagination>
					<!-- 
					<div v-if="orderdetailshow" class="workeatil_alert">
						<div class="title" style="justify-content: space-between;">
							<div>
								<img src='../../assets/img/tit.png' style='height:.2rem;' />
								<img src='../../assets/img/tit.png' style='height:.2rem;' />
								工单详情
							</div>						
							<img src='../../assets/img/close.png' style="height: .2rem;" v-on:click="closeOrderdetail" />
						</div>	
						<div>
							<div class="data">								
								<div>
									<img src='../../assets/img/tit3.png' style='height:.13rem;align-self: center;' />
									作业名称
								</div>
								<div class="fonto">{{orderdetail.missionName}}</div>
							</div>
							<div class="data">
								<div>
									<img src='../../assets/img/tit3.png' style='height:.13rem;align-self: center;' />
									开始时间
								</div>
								<div class="fonto">{{orderdetail.timeStart}}</div>
							</div>
							<div class="data">
								<div>
									<img src='../../assets/img/tit3.png' style='height:.13rem;align-self: center;' />
									结束时间
								</div>
								<div class="fonto">{{orderdetail.timeEnd}}</div>
							</div>
							<div class="data">
								<div>
									<img src='../../assets/img/tit3.png' style='height:.13rem;align-self: center;' />
									清扫面积
								</div>
								<div class="fonto">{{orderdetail.area}} 平方米</div>
							</div>
							<div class="data">
								<div>
									<img src='../../assets/img/tit3.png' style='height:.13rem;align-self: center;' />
									开始距离
								</div>
								<div class="fonto">{{orderdetail.distance}} 米</div>
							</div>
							<div class="data">
								<div>
									<img src='../../assets/img/tit3.png' style='height:.13rem;align-self: center;' />
									任务进度
								</div>
								<div class="fonto">{{orderdetail.coverTraj}} %</div>
							</div>
						</div>
					</div>
					 -->
				</div>
			</div>	
		</div>
		
	</div>
</template>

<script>

	import {BaiduMap} from 'vue-baidu-map'
	import Pagination from '@/components/Pagination'
	
	import {getIndexCarCamera,cameraFtpPreview,getIndexCarWork,getCarWorkOrder,getCarTrajFromOrder,getCarTrajFromWkStatus,mapTrajFtpPreview} from '../../api/car.js'
	import carlinear from '../../assets/img/carlinear.png'
	
	let bmapTraj;
	var points = [];//原始点信息数组
	var bPoints = [];//百度化坐标数组。用于更新显示范围
	
	let canvas; 
	var ctx;
	var partPoints=[];
	var canvasImageData;
	// var testpoints = {xValue:10,yValue:10};
	
	let zoomCanvas;
	
	export default{
		inject: ['mqttWorkExecute'],
		props: {
			selectedCar:{
				type:String
			},
			mqttRealOrder:{
				type:Object
			},
			mqttRealData:{
				type:Object
			},
			mqttTakePic:{
				type:Object
			},
			mqttRemoteOver:{
				type:Object
			},
			mqttRemoteOverPic:{
				type:Object
			}
		},
		watch: {
			selectedCar:{
				handler(newData) {
					if(newData != null && newData != ""){
						// 计时器正在进行中，退出函数
						// if (this.workInfoIntervalId != null) {
						// 	return;
						// }
						// 计时器为空，操作
						// this.workInfoIntervalId = setInterval(() =>{
							this.clearDataCache()
							this.carid = newData
							this.initCarWorkByCar()
							this.initCarCamera()
						// },5*1000)
					}
				},
				immediate: true, //最初绑定值的时候也执行函数
				deep: true //监听一个对象的改变
			},
			mqttRealOrder:{
				handler(newData){
					if(newData != null){
						
						// this.workList.forEach((item,index)=>{
						// 	if(item.missionName.indexOf(currworkid) > 0){
						// 		this.selectedWork = item
						// 		this.handleSelectWork()
						// 		return
						// 	}
						// })
						
						if(newData.workType == 1){
							if(this.selectedWorkMulti == null){
								return
							}
							if(this.selectedWorkMulti.workId == null){
								return
							}
							if(newData.workId != this.selectedWorkMulti.workId ){
								return
							}
							this.execuWorkOrder = newData
							return
						}
						
						if(this.selectedWork == null){
							return	
						}
						if(this.selectedWork.missionName == null){
							return				
						}
						var wkname = this.selectedWork.missionName
						if(wkname== null){
							return	
						}
						var currworkid = newData.workId	
						if(wkname.indexOf(currworkid) < 1){
							return	
						}						
						this.execuWorkOrder = newData											
					}
				},
				immediate: true,
				deep: true 
			},
			mqttRealData:{
				handler(newData){
					if(newData != null){	
						this.baidulocation.status = newData.status
						if(this.execuWorkOrder != null){
							if(this.execuWorkOrder.workStatus == 3){
								return
							}
							if(this.selectedWork != null || this.selectedWorkMulti !=null){
								var lon = newData.baiduLongitude
								var lat = newData.baiduLatitude
								if(lon>0 && lat>0){
									this.baidulocation.lat = lat
									this.baidulocation.lon = lon
									this.baidulocation.id = this.baidulocation.id + 1
									this.drawLine()
								}
							}
							if(this.selectedWork !=null){
								var hx = newData.xValue
								var hy = newData.yValue
								if(hx > 0 && hy > 0){
									var scalew = this.partlocationScale.canvasScaleW,scaleh = this.partlocationScale.canvasScaleH							
									var partx = hx/scalew,party = hy/scaleh
									var partxy = {
										xValue:partx.toFixed(2),
										yValue:party.toFixed(2)
									}
									partPoints.push(partxy)
									this.canvasLine()
								}
							}
						}//					
					}
				},
				immediate: true, 
				deep: true
			},
			mqttTakePic:{
				handler(newData){
					if(newData != null){
						this.takepicinfo = newData
						this.handleTakePic(0,this.takepicinfo)
					}
				},
				immediate: true, 
				deep: true
			},
			mqttRemoteOver:{
				handler(newData){
					if(newData != null){
						this.ctlrsp = newData
					}
				},
				immediate: true, 
				deep: true
			},
			mqttRemoteOverPic:{
				handler(newData){
					if(newData != null){
						this.ctlpicinfo = newData
						this.handleTakePic(1,this.ctlpicinfo)
					}
				},
				immediate: true, 
				deep: true
			}
		},		
		components: {
		   Pagination
		},
		mounted() {
			
		},
		destroyed() {
			// 在页面销毁后，清除计时器
			// this.clearWorkInfo();
		},
		data(){
			return{	
				carid:'',
				// workInfoIntervalId: null,
				camerainfos:[],	
				entyWarnToPicLoading:true,
				entyWarnToPic:false,
					
				takepicinfo:{},
				takepicshow:'',
				picDialogVisible:false,
				picDialogPath:'',
				
				ctlrsp:{},
				ctlpicinfo:{},
				ctlpicshow:'',
				
				localpic3:require('@/assets/img/pic-3.png'),
				localpic5:require('@/assets/img/pic-5.png'),
				
				scrollOption: {
					step: 0.3, // 数值越大速度滚动越快
					limitMoveNum: 2, // 开始无缝滚动的数据量
					hoverStop: true, // 是否开启鼠标悬停stop
					direction: 1, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 2000 // 单步运动停止的时间(默认值1000ms)
				},
				
				wkTabs:['作业','组合作业'],
				wkCurTab:0,
				
				selectedWork:{},
				workList:[],
				
				selectedWorkMulti:{},
				multiWorkList:[],
				
				orderList:[],
				orderQuery: {
				  workId: null,
				  pageIndex: 1,
				  pageSize: 5,
				  orderTotal: 0,
				},
				orderdetailshow:false,
				orderdetail:{},
				
				execuWorkOrder:{},
				baidulocation:{
					lat:0,
					lon:0,
					id:1,
					status:1
				},
				
				partlocationScale:{
					canvasScaleW:1,
					canvasScaleH:1,
				},
				
				workingdetailFlag:false,
				workingdetailInfo:null,
				workingtype:0,
				
				BMap:undefined,
				entityLng:localStorage.getItem('entityLng') == null ? '119.955271' : localStorage.getItem('entityLng'),
				entityLat:localStorage.getItem('entityLat') == null ? '31.831686'  : localStorage.getItem('entityLat'),		
				
				canvasZoomVisible:false,
				canvasClickPosition: { x: 0, y: 0 },
				zoomFactor:2,
				zoomedWidth:'',
				zoomedHeight:''
			}
		},
		methods:{		
			// 停止定时器
		// 	clearWorkInfo() {
		// 		clearInterval(this.workInfoIntervalId); //清除计时器
		// 		this.workInfoIntervalId = null; //设置为null
		// 	}
		// }
			initCarCamera(){
				let that = this
				that.camerainfos = []
				that.loading = true;
				that.loadProgress = { loaded: 0, total: 0 };
				console.log("开始加载图片");
				try{
					getIndexCarCamera(that.carid).then(res=>{
						console.log("获取机器人抓拍文件夹");
						if(res.result == 0){	
							console.log("获取机器人抓拍文件夹成功");
							var camera = res.carCamera
							if(camera != null && camera.length>0){
								// 关键：用Promise.all处理批量异步，确保所有图片URL都获取完成后再赋值
								Promise.all(
									camera.map(async (item, index) => {
										// 1. 先处理同步的时间格式（避免重复操作原数组）
										const newItem = { ...item }; // 浅拷贝，防止修改原数组引发的副作用
										newItem.createTime = newItem.createTime?.substring(newItem.createTime.indexOf(" ")) || '';
										// 2. 等待异步请求完成，再处理图片URL
										const blobRes = await cameraFtpPreview(item.id, item.filePath, item.fileId + ".jpg");
										const url = window.URL.createObjectURL(new Blob([blobRes]));
										newItem.filePath = url;
										// 3. 异步完成后返回处理好的新对象
										return newItem;
									})
								).then(processedCamera => {
									// 4. 所有异步处理完成，统一赋值给渲染数据
									that.camerainfos = processedCamera;
									console.log("所有图片URL处理完成", that.camerainfos);
									that.entyWarnToPicLoading = false
								}).catch(err => {
									// 新增：捕获单张图片加载失败的异常，避免影响全部
									console.error("部分图片预览失败", err);
									this.$message({
										message: '部分抓拍图片加载失败，请重试',
										type: 'warning'
									});
									that.entyWarnToPicLoading = false
								});							
								
								// console.log("开始遍历图片");							
								// that.camerainfos = camera.map((item,index)=>{	
								// 	console.log("轮询获取机器人图片地址",item.id,item.filePath,item.fileId+".jpg");
								// 	cameraFtpPreview(item.id,item.filePath,item.fileId+".jpg").then(res=>{
								// 		console.log("从ftp拿取图片流",res);
								// 	    var url = window.URL.createObjectURL(new Blob([res]));
								// 		console.log("图片加载地址",url);
								// 		item.filePath = url;
								// 		return item;
								// 	})	
								// 	item.createTime = item.createTime.substring(item.createTime.indexOf(" "))
								// 	return item;
								// })	
							}
						}else{
							this.$message({
								message: '未获取到机器人抓拍信息',
								type: 'error'
							});		
							that.entyWarnToPicLoading = false
						}
					})
				} finally {
					this.loading = false;
				}

			},
			picScale(blobdata){
				this.picDialogPath = blobdata
				this.picDialogVisible = true
			},
			handleTakePic(pictype,picinfo){
				let that = this
				// var fileid = that.takepicinfo.fileid
				// var filepath = that.takepicinfo.filepath
				
				var fileid = picinfo.fileid
				var filepath = picinfo.filepath
				
				cameraFtpPreview(that.carid,filepath,fileid+".jpg").then(res=>{
				    var url = window.URL.createObjectURL(new Blob([res]))
					if(pictype == 1 ){
						that.ctlpicshow = url
					}else{
						that.takepicshow = url
					}
					
				})	
			},
			entyWarnToShowPic(){			
				 // 开启定时器，定期检测条件
				  const checkInterval = setInterval(() => {
					if (!this.entyWarnToPicLoading) {
					  // 条件满足，清除定时器（停止轮询）
					  clearInterval(checkInterval);
					  // 执行新方法
					  if(this.camerainfos.length > 0){
							var camera = this.camerainfos[0]
							this.entyWarnToPic = true
							this.picScale(camera.filePath)
						}
					} 
					// else {
					//   console.log("⌛ 等待方法就绪中...");
					// }
				  }, 1000); // 每 1 秒检测一次，可根据需求调整频率	
			},
			handlePicDialogClose(){
				this.picDialogVisible = false
				if(this.entyWarnToPic){
					this.entyWarnToPic = false
				}
			},
			remotePicTask(type){
				let that = this
				if(that.carstatus ==1){
					this.$message({
						message: '机器人不在线',
						type: 'error'
					});
					return
				}
				
				var totast = '机器人拍照'
				if(type == 1){
					totast = '机器人绕障'
				}
				
				this.$confirm("确定下发"+totast,"提示",{
				    iconClass: "el-icon-question",//自定义图标样式
				    confirmButtonText: "确认",//确认按钮文字更换
				    cancelButtonText: "取消",//取消按钮文字更换
				    showClose: true,//是否显示右上角关闭按钮
				    type: "warning",//提示类型  success/info/warning/error
				}).then(()=>{
				  var picdetail={
				  	user:localStorage.getItem('username')
				  }			  
				  var rTaskId = 2
				  
				  if(type == 1){
				  	picdetail={
				  		rType:1,
				  		tPicRate:30
				  	}	
				  	rTaskId = 3					  
				  }
				  
				  var mqttRemote={
				  	RobotID:that.carid,
				  	Timestamp:Number(new Date()),
				  	source:2,
				  	taskId:rTaskId,
				  	payload:picdetail
				  }			
				  that.mqttWorkExecute(mqttRemote)		
				}).catch(() => {
				  	//取消操作
					this.$message({
						type: 'info',
						message: '已取消下发'
					});
				});						
			},
			
			initCarWorkByCar(){
				let  that = this
				that.selectedWork = null
				that.selectedWorkMulti = null
				getIndexCarWork(that.carid).then(res =>{
					if(res.result == 0){
						if(res.carWorkList != null && res.carWorkList.length > 0){
							that.workList = res.carWorkList
							
							if(that.workingdetailFlag && that.workingtype == 0){
								that.selectedWork = that.workingdetailInfo
								that.wkCurTab = 0
								that.handleSelectWork(0)								
								
								that.workingdetailFlag = false
								that.workingdetailInfo = null
							}
						}else{
							that.workList = []
							this.$message({
								message: '机器人暂无作业信息',
								type: 'info'
							});
						}
						if(res.carMultiWorkList != null && res.carMultiWorkList.length > 0){
							that.multiWorkList = res.carMultiWorkList.map((item,index)=>{							
								if(that.workingdetailFlag && that.workingtype == 1){
									if(that.workingdetailInfo.id == item.id){
										that.selectedWorkMulti = item
										that.wkCurTab = 1 
										that.handleSelectWork(1)									
										
										that.workingdetailFlag = false
										that.workingdetailInfo = null
									}
								}
								
								var array = item.subWorkArray.split(',')
								item.subWork = ''
								for(var i = 0 ; i < array.length-1 ; i ++){
									var wkname = array[i],wk = wkname.substring(0,wkname.indexOf('-'))	
									item.subWork += wk + ','
								}														
								return item								
							})		
						}else{
							that.carMultiWorkList = []
							this.$message({
								message: '机器人暂无组合作业信息',
								type: 'info'
							});
						}	
					}else{
						this.$message({
							message: '未获取到机器人作业信息',
							type: 'error'
						});
					}
				})
			},
			wkTabChange(key) {
				this.wkCurTab = key;
			},
			handleSelectWork(flag){		
				this.execuWorkOrder = {}
				if(flag == 1){
					this.selectedWork = null
					this.initOrderyWork()
					this.initTrajByWorkSta()
				}else{
					this.selectedWorkMulti = null	
					this.initOrderyWork()
					this.initCanvasPic()
					this.initTrajByWorkSta()				
				}								
			},
			initCanvasPic(){
				let that = this
				var carid = this.selectedWork.carId 
				var mapTraj = this.selectedWork.missionMap
				var mapnum = mapTraj.substring(mapTraj.indexOf('-')+1)
				var trajurl = this.selectedWork.networkPic
				let trajname = trajurl.substring(trajurl.lastIndexOf('/')+1)
				//let trajnet = 'https://mqtt.techinao.com/'+trajname
				
				var imgActualW,imgActualH
				var scaleW = 1,scaleH =1
				
				canvas = document.getElementById('myPicCanvas');
				canvas.width = 200 //设置画布宽
				canvas.height = 200 //设置画布高
				ctx = canvas.getContext('2d');			
				
				mapTrajFtpPreview(carid,2,mapnum,trajname).then(res=>{
					console.log("从ftp拿取地图图片流",res);
				    var imgUrl = window.URL.createObjectURL(new Blob([res]));
					console.log("图片加载地址",imgUrl);
					var bkImage = new Image();
					bkImage.src = imgUrl; 
					bkImage.onload = function () {
					    ctx.drawImage(bkImage, 0, 0,canvas.width,canvas.height); // 将图片绘制到canvas上（左上角）
						ctx.save();
						canvasImageData = ctx.getImageData(0, 0,canvas.width,canvas.height)
						
						window.URL.revokeObjectURL(imgUrl);
						
						imgActualW = bkImage.width
						imgActualH = bkImage.height
						
						scaleW = imgActualW/canvas.width
						scaleH = imgActualH/canvas.height
						
						that.partlocationScale.canvasScaleH = scaleH
						that.partlocationScale.canvasScaleW = scaleW
					};				
				})	
				
				// var bkImage = new Image();
				// bkImage.crossOrigin = 'Anonymous'; // 或者 ''
				// bkImage.src = trajurl; // 指定PNG图片路径	 trajurl;	 trajnet 
				// bkImage.onload = function () {
				//     ctx.drawImage(bkImage, 0, 0,canvas.width,canvas.height); // 将图片绘制到canvas上（左上角）
				// 	ctx.save();
				// 	canvasImageData = ctx.getImageData(0, 0,canvas.width,canvas.height)
					
				// 	imgActualW = bkImage.width
				// 	imgActualH = bkImage.height
					
				// 	scaleW = imgActualW/canvas.width
				// 	scaleH = imgActualH/canvas.height
					
				// 	that.partlocationScale.canvasScaleH = scaleH
				// 	that.partlocationScale.canvasScaleW = scaleW
				// };
			},
			canvasLine(){
				if(ctx == null){
					return
				}
				var len = partPoints.length
				if(len > 1){
					// ctx.globalCompositeOperation = "destination-out"
					 // 绘制所有的线
					ctx.beginPath();			
					// ctx.moveTo(partPoints[0].xValue, partPoints[0].yValue);
					// for (let i = 1; i < partPoints.length; i++) {
					//     ctx.lineTo(partPoints[i].xValue, partPoints[i].yValue);
					// }
					ctx.moveTo(partPoints[len-2].xValue, partPoints[len-2].yValue);
					ctx.lineTo(partPoints[len-1].xValue, partPoints[len-1].yValue);
					ctx.strokeStyle = 'red';
					ctx.stroke();
					// ctx.closePath();					
				}
			},
			clearCanvasLine(){
				// ctx.putImageData(canvasImageData, 0, 0); 
				// ctx.clearRect(0, 0, canvas.width,canvas.height);
			},
			reloadCanvasPic(){
				var bkImage = new Image();
				bkImage.src = this.selectedWork.networkPic;
				bkImage.onload = function () {
				    ctx.drawImage(bkImage, 0, 0,200,200);
				}
			},
			
			// newCanvaslinePoint(){				
			// 	partPoints.push(testpoints)
			// 	var px = testpoints.xValue + 10
			// 	var py = testpoints.yValue + 8
			// 	var pxy = {
			// 			xValue:px,
			// 			yValue:py
			// 		}
			// 	partPoints.push(pxy)
			// 	testpoints.xValue = px
			// 	testpoints.yValue = py
			// 	this.canvasLine()
			// },	
			
			initTrajByWorkSta(){
				
				let that = this
				var workid 
				if(this.wkCurTab == 1){
					 workid = that.selectedWorkMulti.id
				}else{
					 workid = that.selectedWork.id
				}
				getCarTrajFromWkStatus(workid).then(res =>{
					if(res.result == '0'){
						if(res.carMapList != null && res.carMapList.length > 0){
							res.carMapList.forEach((item,index)=>{
								var lon = item.baiduLongitude
								var lat = item.baiduLatitude
								if(lon>0 && lat>0){
									this.baidulocation.lat = lat
									this.baidulocation.lon = lon
									this.baidulocation.id = this.baidulocation.id + 1
									this.drawLine()
								}
								if(this.wkCurTab == 1){
									return
								}
								
								var hx = item.xValue
								var hy = item.yValue
								if(hx > 0 && hy > 0){
									var scalew = this.partlocationScale.canvasScaleW,scaleh = this.partlocationScale.canvasScaleH							
									var partx = hx/scalew,party = hy/scaleh
									var partxy = {
										xValue:partx.toFixed(2),
										yValue:party.toFixed(2)
									}
									partPoints.push(partxy)
									this.canvasLine()
								}
							})
						}else{//length>0
							this.$message({
								message: '未获取到作业当前轨迹信息',
								type: 'info'
							});
						}
					}else{//sucess
						this.$message({
							message: '未获取到作业当前轨迹信息',
							type: 'error'
						});
					}
				})
			},		
			initOrderyWork(){
				let  that = this	
				if(that.selectedWorkMulti == null && that.selectedWork ==null){
					return
				}	
				if(that.selectedWorkMulti != null){
					that.orderQuery.workId = that.selectedWorkMulti.id					
				}else{
					that.orderQuery.workId = that.selectedWork.id
				}			
				getCarWorkOrder(that.orderQuery).then(res =>{
					if(res.result == 0){
						if(res.workOrderList != null && res.count > 0){
							that.orderList = res.workOrderList
							that.orderQuery.orderTotal = res.count
						}else{
							that.orderList = []
							var ordernone = {
								serialId:'无工单'
							}
							that.orderList.push(ordernone)
						}	
					}else{
						this.$message({
							message: '未获取到作业工单信息',
							type: 'error'
						});
					}
				})
			},
			handleOrderPageList(data){
				if(this.selectedWorkMulti == null && this.selectedWork ==null){
					return
				}
				if(this.selectedWorkMulti != null){
					this.orderQuery.workId = this.selectedWorkMulti.id					
				}else{
					this.orderQuery.workId = this.selectedWork.id
				}	
				this.orderQuery.pageIndex = data.page
				this.orderQuery.pageSize = data.limit
				this.initOrderyWork()
			},
			showOrderdetail(row){
				// this.orderdetail = row
				// this.orderdetailshow = true

				this.execuWorkOrder = {}
				
				this.execuWorkOrder.workStart = row.timeStart
				this.execuWorkOrder.workEnd = row.timeEnd
				this.execuWorkOrder.workArea = row.area
				this.execuWorkOrder.workDistance = row.distance
				this.execuWorkOrder.workCover = row.coverTraj
				this.execuWorkOrder.workType = row.workType
				
				if(row.workType == 0){
					this.reloadCanvasPic()
					partPoints=[]			
				}
				
				bmapTraj.clearOverlays();
				points=[]
				bPoints=[]			
				
				getCarTrajFromOrder(this.carid,row).then(res =>{
					if(res.result == '0'){
						if(res.carMapList != null && res.carMapList.length > 0){
							res.carMapList.forEach((item,index)=>{
								var lon = item.baiduLongitude
								var lat = item.baiduLatitude
								if(lon>0 && lat>0){
									this.baidulocation.lat = lat
									this.baidulocation.lon = lon
									this.baidulocation.id = this.baidulocation.id + 1
									this.drawLine()
								}
								
								if(row.workType == 1 ){
									return				
								}
								
								var hx = item.xValue
								var hy = item.yValue
								if(hx > 0 && hy > 0){
									var scalew = this.partlocationScale.canvasScaleW,scaleh = this.partlocationScale.canvasScaleH							
									var partx = hx/scalew,party = hy/scaleh
									var partxy = {
										xValue:partx.toFixed(2),
										yValue:party.toFixed(2)
									}
									partPoints.push(partxy)
									this.canvasLine()
								}
							})
						}else{//length>0
							this.$message({
								message: '未获取到作业历史轨迹信息',
								type: 'info'
							});
						}
					}else{//sucess
						this.$message({
							message: '未获取到作业历史轨迹信息',
							type: 'error'
						});
					}
				})
				
			},
			closeOrderdetail(){
				this.orderdetailshow = false
			},
			remoteTask(cmd){			
				let that = this
				if(that.baidulocation.status ==1){
					this.$message({
						message: '机器人不在线',
						type: 'error'
					});
					return
				}			
				if(cmd == 4){
					this.$confirm("确定下发机器人返航","提示",{
					    iconClass: "el-icon-question",//自定义图标样式
					    confirmButtonText: "确认",//确认按钮文字更换
					    cancelButtonText: "取消",//取消按钮文字更换
					    showClose: true,//是否显示右上角关闭按钮
					    type: "warning",//提示类型  success/info/warning/error
					}).then(()=>{
					   var backdetail={
					   	user:localStorage.getItem('username')
					   }
					   var mqttRemote={
					   	RobotID:that.carid,
					   	Timestamp:Number(new Date()),
					   	source:2,
					   	taskId:1,
					   	payload:backdetail
					   }			
					   that.mqttWorkExecute(mqttRemote)		
					}).catch(() => {
					  	//取消操作
						this.$message({
							type: 'info',
							message: '已取消下发'
						});
					});		
				}else{					
					if(that.selectedWork == null && that.selectedWorkMulti == null){
						that.$message({
							message: '请选择作业',
							type: 'error'
						});
						return
					}															
																					
					this.$confirm("确定下发机器人作业","提示",{
					    iconClass: "el-icon-question",//自定义图标样式
					    confirmButtonText: "确认",//确认按钮文字更换
					    cancelButtonText: "取消",//取消按钮文字更换
					    showClose: true,//是否显示右上角关闭按钮
					    type: "warning",//提示类型  success/info/warning/error
					}).then(()=>{
						
						let loginuser = localStorage.getItem('username')
						var userid
						
						var workname, type = 0;
						if(that.selectedWorkMulti != null){
							 workname = that.selectedWorkMulti.workId	
							 type = 1
							 userid = that.selectedWorkMulti.userId	
						}else{
							 workname = that.selectedWork.missionName	
							 userid = that.selectedWork.userid	
						}
						if(loginuser != userid && loginuser != 'admin'){
							that.$message({
								message: '您暂无此权限',
								type: 'error'
							});
							 return
						}
						
					    //确认操作
						var workdetail={
							execute:cmd,
							type:type,
							name:workname,
							user:loginuser
						}
						var mqttRemote={
							RobotID:that.carid,
							Timestamp:Number(new Date()),
							source:2,
							taskId:0,
							payload:workdetail
						}
						that.mqttWorkExecute(mqttRemote)
					}).catch(() => {
					  	//取消操作
						this.$message({
							type: 'info',
							message: '已取消下发'
						});
					});			
				}//
			},	
			// takeRemote(cmd){
			// 	let that = this
			// 	remoteTakeEmergency(that.carid,cmd).then(res =>{
			// 		if(res.result == 0){
			// 			this.$message.success('下发成功')
			// 		}else{
			// 			this.$message.error('下发失败')
			// 		}
			// 	})
			// },
			// newPolylinePoint(){
			// 	this.baidulocation.lat = this.baidulocation.lat + 10
			// 	this.baidulocation.lon = this.baidulocation.lon + 30
			// 	this.baidulocation.id = this.baidulocation.id + 1
			// 	this.drawLine()
			// },			
			/** 加载地图 **/			
			bmapTraj_ready({
				BMap,
				map
			}){
				console.log("BaiduMap is ready")
				this.BMap = BMap
				bmapTraj = map	
				bmapTraj.setCenter(new BMap.Point(this.entityLng,this.entityLat))
				bmapTraj.setZoom(19);  
			},
			//新的点，加入到轨迹中
			drawLine(){
				if(bmapTraj == null){
					return
				}
				var lng = this.baidulocation.lon
				var lat = this.baidulocation.lat
				if(lat >0 && lng > 0){
					var id = this.baidulocation.id
					var point = {"lng":lng,"lat":lat,"status":1,"id":id}
					var makerPoints = [];
					var newLinePoints = [];
					var len;
						 
					makerPoints.push(point);			
					// this.addMarker(makerPoints);//增加对应该的轨迹点
					points.push(point);
					bPoints.push(new BMap.Point(lng,lat));
					len = points.length;
					newLinePoints = points.slice(len-2, len);//最后两个点用来画线。
						 
					this.addLine(newLinePoints);//增加轨迹线
					this.setZoom(bPoints);
				}
			},
			//在轨迹点上创建图标，并添加点击事件，显示轨迹点信息。points,数组。
			addMarker(points){
				var pointsLen = points.length;
				if(pointsLen == 0){
					return;
				}
				var myIcon = new BMap.Icon(carlinear, new BMap.Size(5, 5), {
					offset: new BMap.Size(5, 5) 
				});

				// 创建标注对象并添加到地图   
				for(var i = 0;i <pointsLen;i++){
					var point = new BMap.Point(points[i].lng,points[i].lat);
					var marker = new BMap.Marker(point, {icon: myIcon});
					bmapTraj.addOverlay(marker); 
				}
			},   
			//添加线
			addLine(points){ 
				var linePoints = [], pointsLen = points.length, polyline;
				if(pointsLen == 0){
					return;
				}
				// 创建标注对象并添加到地图   
				for(var i = 0;i < pointsLen;i++){
					linePoints.push(new BMap.Point(points[i].lng,points[i].lat));
				}
	 
				polyline = new BMap.Polyline(linePoints, {strokeColor:"red", strokeWeight:2, strokeOpacity:0.5});   //创建折线
				bmapTraj.addOverlay(polyline);   //增加折线
			},
			//根据点信息实时更新地图显示范围，让轨迹完整显示。设置新的中心点和显示级别. 
			//更新。设置不是每次增加点都重新设置显示范围。因为有可能会想放大了看。
			setZoom(bPoints){
				var view = bmapTraj.getViewport(eval(bPoints));
				if(bmapTraj.oldView != JSON.stringify(view)){
					var mapZoom = view.zoom; 
					var centerPoint = view.center; 
					bmapTraj.centerAndZoom(centerPoint,mapZoom);
					bmapTraj.oldView = JSON.stringify(view);
				}
			},
			clearDataCache(){
				this.warningList = []
				
				this.wkCurTab = 0				
				this.selectedWork = {}
				this.workList = []				
				this.selectedWorkMulti = {}
				this.multiWorkList = []				
				
				this.orderList = []
				
				this.execuWorkOrder = {}
				partPoints=[]
				if(ctx != null){
					ctx.clearRect(0,0,200,200)
				}			
				
				points=[]
				bPoints=[]
				if(bmapTraj != null){
					bmapTraj.clearOverlays()
				}
							
				// this.workingdetailFlag = false
				// this.workingdetailInfo = null
			}
		}
	}		
	
</script>

<style lang="scss" scoped>
	
	.picdialog{
		margin-top: -1.5%;
		
		:deep(.el-dialog) {
			.el-dialog__header {
			    background: rgba(22,26,99,.9);
				padding: 10px 0 5px 0;			    
				border: 1px solid rgba(22,26,99,1);
				border-bottom: solid 1px #19F2EB ;
				.el-dialog__title{
					color: #fff;
				}
				.el-dialog__headerbtn{
					top:10px
				}
			}
			.el-dialog__body {
			    background: rgba(22,26,99,.9); 
				border: 1px solid rgba(22,26,99,1);
			}
		}
	}
	
	.container{
		z-index: 10;
		position: fixed;
		bottom: 0;
		width: 100%;
		display: flex;
		flex-direction: row;
		color: #fff;
		justify-content: space-between;
		// height: 3.5rem;
	}
	.btn{
		height: .3rem;
		width: 1rem;
	}
	.btn2{
		height: .3rem;
		// width: .5rem;
		padding: 0 0.1rem;
		align-self: center;
	}
	.warn_work{
		display: flex;
		flex-direction: column;
		padding:.1rem;
		padding-bottom: .2rem;
		background:rgba(22,26,99,.8);
		.title{
			padding:.05rem;
			font-size: .16rem;
			text-align: left;
			border-bottom:.02rem solid #19F2EB;
			display: flex;
			flex-direction: row;
		}
		
		.wktabdiv {
		    /* height: 0.3rem; */
		    // width: 1.8rem;
		    // background-color: #fff;
		    color: #fff;
		    display: flex;
		    justify-content: space-evenly;
		    align-items: center;
		    list-style: none;
			padding: 0;
			margin: 0;
		}
		 
		.wktabtit {
		    width: .8rem;
		    text-align: center;
		    line-height: .3rem;
		    font-size: 12px;
		}
		
		.active {
			// background-color:rgba(22,26,99,1);;
			color: rgb(3,166,224);
			font-weight:bold;
			font-size: 14px;
		}
		
		.info{
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			font-size: .12rem;
			.datachart{
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				padding:.1rem .2rem;
				.dataimg{
					align-self: center;
					height: 0.25rem;
					padding-right:.15rem;
				}
				.data{
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					line-height: .25rem;
					.fontg{
						color:#19F2EB;
					}
					.fonto{
						color:#d6a615;
					}
				}
			}
			.datapic{
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				.fonto{
					color:#d6a615;
					padding-top: .1rem;
				}
				.pic{
					width: 1rem;
					height: 1rem;
					border: .01rem solid rgba(22,26,99,1);
					padding-bottom:.05rem;
				}
			}
		}

		
		.car_work{
			display: flex;
			flex-direction: row;
			.box{
				overflow: hidden;
				position: relative;
				z-index: 10;
				width: 4rem;
				height: 3rem;
			}
			.boxnav {
			  text-align: center;
			  white-space: nowrap;
			  // height:calc(100% - .4rem); 
			  display: flex;
			  flex-direction: row;
			  justify-content: space-between;
			  align-items: center;
			  padding: .2rem 0;
			}			
			.boxitem {
			  margin: auto; 
			  text-align: left;
			  text-overflow: ellipsis; /*显示省略符号来代表被修剪的文本*/
			  white-space: nowrap; /* 不换行 */
			  overflow: hidden; 
			  // width:1.5rem;
			  font-size: .15rem;
			}
			.workdetail{
				line-height: .5rem;
				// width: 3rem;
				padding-right:.5rem;
				div{
					text-align: left;
					display: flex;
					
					div{
						padding-left: .1rem;
					}
				}
			}
			.worktraj{
				width: 2.5rem;
				display: flex;
				justify-content: center;
				flex-direction: column;
				padding-top: 0.1rem;			
			}
			.workbaidu{
				width: 2.5rem;
				padding-top: .1rem;
				padding-left: .1rem;
			}
			.orderdetail{
				line-height: .45rem;	
				// padding-left: .5rem;
				position: fixed;
				right: 8rem;				
				div{
					border-bottom: .06rem solid #165C9E;
					display: flex;
				}
				img{
					padding: 0 0.1rem;
				}
			}
			.orderlist{
				position: fixed;
				padding-top: .1rem;
				overflow: hidden;		
				right: .15rem;
				width: 5rem;
				.title3{
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					line-height: .4rem;
					background: #165C9E;
					// div{
					// 	padding-left: .2rem;
					// 	padding-right: .39rem;
					// }
				}
				.orderlistdiv{
					height: 2.1rem;
					overflow-y: scroll;
					margin-right: -20px
				}
				.orderlistinfo{
					display: flex;
					flex-direction: row;
					justify-content: space-around;
					line-height: .4rem;
				}
				.workeatil_alert{
					position: fixed;
					bottom: 15%;
					background:rgba(22,26,99,1);
					border: .01rem solid #fff;
					width: 4rem;
					.data{
						display: flex;
						flex-direction: row;
						justify-content: space-evenly;
						line-height: .4rem;
					}
				}
			}
		}
		
		.selector{
			height: .3rem;
			width: 3rem;
			background:#165C9E;
			color: #fff;
			margin-left: .2rem;
			// .selector option:disabled{
			// 	background:rgba(22,26,99,1);
			// }
			// .selector option{
			// 	background:rgba(22,26,99,1);
			// }
		}
		.title_info{
			display: flex;
			flex-direction: row;
			justify-content: start;
			font-size: 0.15rem;
			align-items: center;
		}
	}
	.row{
		display: flex;
		flex-direction: row;
		justify-content: center;
	}
	
	
	
</style>
